module.exports = __webpack_public_path__ + "img/user.814ef03c.svg";